import {
    AnalyticsEvent,
    EVENT_UAEVENT,
    GTMEcommerceData,
    getAnalyticsDeviceType,
} from "@hermes/utils/analytics";

import { ECOMMERCE } from "../constants/grid.constant";
import { PageEventData } from "../events/page-event-data";

export interface GTMPageViewData {
    event: string;
    pagename: string;
    pagetype: string;
    languagecode: string;
    countrycode: string;
    buildVersion: string;
    devicetype: string;
    userId?: string;
    clienttype: string;
    clientgender: string;
    pageTranslate: string;
    menu_lv1?: string;
    menu_lv2?: string;
    menu_lv3?: string;
    departmentcode: string;
    category: string;
    action: string;
    ecommerce?: GTMEcommerceData;
}

const IMPRESSIONS_EVENT = "impressions";
export class GridProductLazyLoadedEvent
    implements AnalyticsEvent<GTMPageViewData>
{
    public name: string = EVENT_UAEVENT;
    public eventData: PageEventData;

    constructor(eventData: PageEventData) {
        this.eventData = eventData;
    }

    /**
     * Return the GTM page view data
     *
     * @param pageEventData     The current page event data
     */
    public formatForGTM(): GTMPageViewData {
        const user = this.eventData.user;

        return {
            event: IMPRESSIONS_EVENT,
            pagename: document.title,
            pagetype: this.eventData.pagetype,
            languagecode: this.eventData.languagecode,
            countrycode: this.eventData.countrycode,
            buildVersion: this.eventData.buildVersion,
            devicetype: getAnalyticsDeviceType(),
            userId: undefined,
            clienttype: user ? user.getUserType() : "non-connected",
            clientgender: user ? user.prefix : "",
            menu_lv1: this.eventData.menuLevel?.menuLv1,
            menu_lv2: this.eventData.menuLevel?.menuLv2,
            menu_lv3: this.eventData.menuLevel?.menuLv3,
            pageTranslate: this.eventData.pageTranslate,
            departmentcode: this.eventData.departmentcode ?? "",
            category: ECOMMERCE,
            action: IMPRESSIONS_EVENT,
            ecommerce: {
                impressions: this.eventData.impressions,
            },
        };
    }
}
